<template lang="html">

  <div>

    <section class="intro-simulador -resultados container row-start aifs" v-if="!!results">

    <img src="/static/img/cerdo.webp" class="cerdo">

    <div class="contenedor-textos">

      <h2>¡Enhorabuena!</h2>
      
      <h4>¡Ya tenemos tu tarifa perfecta!</h4>
      <h4 v-if="!!results.iner_results.ahorro">¡Y te vas a ahorrar un montón!</h4>

      <p>Basándonos en la información que nos has proporcionado y en los datos de tu instalación con Iner tendrías una factura media mensual de:</p>

      <h3>{{results.iner_results.coste}}€/mes</h3>

      <p class="tip">*Precio IVA incluido</p>

      <p v-if="!!results.iner_results.ahorro">Hemos calculado que con nosotros ahorrarías {{results.iner_results.ahorro}}€ cada año.</p>

      <div class="result-ok row-start" v-if="hasemail">
        <span class="tick">
          <img src="/static/img/tick.svg" alt="">
        </span>
        <h4>Te hemos enviado un email con <template v-if="!!results.iner_results.ahorro">tu cálculo de ahorro y</template> toda la información.</h4>
      </div>

    </div>
    
    <div class="contenedor-ahorro column-center" v-if="!!results.iner_results.ahorro">

      <h4>Tu ahorro es de:</h4>

      <h2>{{results.iner_results.ahorro}}€</h2>

      <p class="year">Al año</p>

      <router-link class="btn -degree" :to="$t('enlaces.inergizate')">Contratar</router-link>

    </div>

  </section>


  <section class="banner-llamada container row-between">
    <div class="contenedor-texto">
    <p>Nos encantaría que empezases a ahorrar desde hoy con nosotros, llámanos y consultanos cualquier duda que tengas.</p>
    <p><strong>Ahora que ya sabes que con Iner tienes el ahorro garantizado llámanos e infórmate.</strong></p>
  </div>
  <a class="btn -skull-orange -gray-c" href="tel:900848402"><span @click="sendeventllamar">Llámanos</span></a>

  </section>


  <grafica-tu-perfil :results="results.iner_results.graph"></grafica-tu-perfil>

  <resultados-competencia :results="results"></resultados-competencia>



  <section class="resumen-ahorro row-start" v-if="!!results.iner_results.ahorro">


    <div class="contenedor-imagen" v-if="results.iner_results.reasons.length > 0">

      <img src="/static/img/cable-de-pie.webp">

    </div>

    <div class="contenedor-texto">

      <h2>Tu ahorro</h2>

      <div class="resultados">

        <h4>¿De dónde viene este ahorro?</h4>
        <h4>El ahorro estimado se ha calculado en base a:</h4>

        <div class="contenedor-checks">
          <template v-for="reason in results.iner_results.reasons">
            <h5 class="check" :important="reason.important">{{reason.texto}}</h5>
            <p>{{reason.subtext}}</p>
          </template>

          <div class="contenedor-subreasons" v-if="results.iner_results.alerts.length > 0">
            <p v-for="reason in results.iner_results.alerts">{{reason}}</p>
          </div>

        </div>

      </div>


    </div>

  </section>


  <section class="mas-cosas-resumen-ahorro">

    <div class="container">
      <h2>
        <span class="-orange">!Ahorra</span>
        <span class="-purple">aún más!</span>
      </h2>
    </div>

    <div class="cosas-things row-start">

      <article class="batido">

        <div class="contenedor-titulo column-center">

          <h2>Gas a precio<br>de un batido</h2>

        </div>

      </article>


      <article class="texto column-start">

        <h4>Te ofrecemos la tarifa de gas más atractiva del mercado</h4>
        <p>Nuestro concepto para las tarifas de gas es el mismo que utilizamos en nuestras tarifas de luz.Te ofrecemos el gas a precio de coste (exactamente lo que nos cuesta a nosotros) y una cuota mensual de gestión de lo mismo que te cuesta un batido.</p>

        <router-link :to="$t('enlaces.tarifas_gas')" class="btn -degree">Ver tarifas de Gas</router-link>

      </article>

      <article class="blog column-start">


        <h4>En Iner te asesoramos diariamente y una vez seas un iner estudiaremos tu caso particular para ver cómo podemos conseguir ahorra más.</h4>

        <router-link :to="$t('enlaces.blog')" class="btn -skull-orange -gray-c">Ir al Blog</router-link>

        <img src="/static/img/imagen-blog-resultado-ahorro.webp" class="imagen-blog">
        
      </article>

      <img src="/static/img/figuras-moradas.gif" class="figuras-moradas">
      
    </div>

  </section>




  <banner-inergizate></banner-inergizate>
  <banner-acceso-contacto></banner-acceso-contacto>

</div>

</template>

<script lang="js">

  import bannerAccesoContacto from '@/components/parts/banner-acceso-contacto';
  import bannerInergizate from '@/components/parts/banner-inergizate';
  import resultadoscompetencia from '@/components/view-parts/simulador/resultados-competencia';

  import graficaTuperfil from '@/components/view-parts/simulador/grafica-tu-perfil'

  import {mapGetters} from 'vuex';


  export default  {
    name: 'result-view',
    props : ['results','hasemail'],
    methods : {
      sendeventllamar() {
        this.$ga.event({
          eventCategory: 'Simulador',
          eventAction: 'clic',
          eventLabel: 'clic-llamada',
          eventValue: 1
        });
        this.gtag_report_conversion();
      },
      gtag_report_conversion(url) {
      const callback = function () {
        if (typeof url !== 'undefined') {
          window.location = url;
        }
      };
      if (typeof gtag !== 'undefined') {
        gtag('event', 'conversion', {
          'send_to': 'AW-692816998/WlrfCIOgwfYaEOaYrsoC',
          'value': 1.0,
          'currency': 'EUR',
          'event_callback': callback
        });
      }
      return false;
    },
    },
    filters :{
      point(value){
        if(!!value){
         let array = String(value).split(".");
        array[1] = array[1].substring(0,2);
        return array.join(',');
        }else{
          return value;
        }
      }
    },
    components :{
      'banner-acceso-contacto' : bannerAccesoContacto,
      'banner-inergizate' : bannerInergizate,
      'resultados-competencia': resultadoscompetencia,
      'grafica-tu-perfil' : graficaTuperfil
    },
    computed:{
      ...mapGetters({
        precios : 'getPrecios'
      })
    }
  }
</script>

<style scoped lang="scss">

  @import '@/assets/css/colors.scss';

  .contenedor-textos{
    display: inline-block;
    max-width: 450px;
    text-align: left;
    margin-right: 50px;

    h3{
      margin-top: 10px;
      font-size: 40px;
      margin-bottom: 0;
      line-height: .9em;
    }

    h3 + p{
      margin-top: 0;
      margin-bottom: 20px;
    }

    p.tip{
      font-size: 14px;
      margin-top: 0;
      margin-bottom: 0;
    }

    p{
      margin-top: 20px;
      font-size: 16px;
      font-weight: 400;
    }

  }


  .contenedor-ahorro{
    width: 310px;
    height: 310px;
    border-radius: 50%;
    background: $degree;
    text-align: center;
    margin-left: 50px;
    position: relative;
    margin-top: 0;


    h4{
      text-transform: uppercase;
      color: white;
    }

    h2{
      text-align: center;
      color: white;
      margin-bottom: 10px;
    }

    .year{
      width: 100%;
      text-align: center;
      text-transform: uppercase;
      color: white;
    }
    
    .btn{
      position: absolute;
      bottom: -70px;
      left: 50%;
      transform: translateX(-50%) translateY(100px);
      opacity: 0;
      animation-name: showbuttoncontratar;
      animation-duration: 1s;
      animation-delay: 1s;
      -webkit-animation-fill-mode: forwards;
      -o-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }

  }

  @keyframes showbuttoncontratar{
    to{
      opacity: 1;
      transform: translateX(-50%);
    }
  }
  
  .result-ok{
    position: relative;
    z-index: 3;
    margin-bottom: 30px;
    margin-top: 15px;

    .tick{
      background: $orange;
      width: 40px;
      height: 40px;
      line-height: 40px;
      display: inline-block;
      text-align: center;
      border-radius: 50%;
      margin-right: 10px;
      transform: translateY(-10px);
    }

    h4{
      max-width: calc(100% - 60px);
    }
  }

  @media screen and (max-width: 1400px){
    .contenedor-ahorro{
      margin-left: 0;
    }
  }

  @media screen and (max-width: 900px){

    .contenedor-textos{
      margin-right: 20px;
      max-width: calc(100% - 270px);
    }

    .contenedor-ahorro{
      width: 250px;
      height: 250px;
      h2{
        font-size: 50px;
      }
      h4{
        font-size: 18px;
      }
      h2{
        line-height: .9em;
      }
    }

  }


  @media screen and (max-width: 767px){ 


    .intro-simulador{
      -ms-align-items: center;
      align-items: center;
      justify-content: center;
      -webkit-justify-content: center;

      .cerdo{
        display: inline-block;
        max-width: 200px;
        right: 0;
        left: auto;
        top: 0;
        bottom: auto;
        display: none;
      }
    }


    .contenedor-textos{
      max-width: 100%;
      width: 100%;
      margin-right: 0;
      p{
        margin-bottom: 20px;
      }
    }

    .result-ok{
      margin-bottom: 0;
      h4{
        font-size: 20px;
      }
    }


    .contenedor-ahorro{
      margin-top: 30px;
      -webkit-order: 4;
      -moz-order: 4;
      -ms-order: 4;
      -o-order: 4;
      order: 4;
      margin-bottom: 80px;
    }



  }


  @media screen and (max-width: 450px){

    .intro-simulador h2{
      font-size: 38px;
    }

    .contenedor-ahorro{
      width: 100%;
      border-radius: 0;
      height:auto;
      padding: 40px 0;
      margin-top: 20px;

      h2{
        font-size: 55px;
      }
    }

    .contenedor-textos p{
      margin-bottom: 0;
      margin-top: 0;
    }

    .contenedor-textos h3 + p{
      margin-bottom: 0;
    }
  }
  
</style>



// WEBPACK FOOTER //
// src/components/view-parts/simulador/result-view.vue